import { createContext } from "react"
import { defaultAppCTX, defaultGameBoardCTX, defaultVauleCTX, roundUserContext } from "./defaultContext"

export const AppContext = createContext(defaultAppCTX)
export const GameBoardContext = createContext(defaultGameBoardCTX)
export const RoundUserContext = createContext(roundUserContext)
export const ValueContext = createContext(defaultVauleCTX)